import React from "react";
import {Create, required, SimpleForm, TextInput,} from "react-admin";

import {PostBottomToolbarAdd} from "../CustomElements/PostBottomToolbars";

const requiredField = required();

export default (props) => {
  return (
    <Create {...props} title={`Dodaj użytkownika`}>
      <SimpleForm toolbar={<PostBottomToolbarAdd />}>
        <div className="d-flex w-100 justify-content-around">
          <div class="col-md-4">
            <div class="table">
              <table class="table table-striped">
                <tr>
                  <td>
                    <TextInput
                      source="name"
                      label="Nazwa"
                      variant="outlined"
                      fullWidth
                      validate={requiredField}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </SimpleForm>
    </Create>
  );
};
